import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';
import { MulticlientInfoItem } from '../../core/model/multiclient';
import { AuthenticationService } from '../../core/services/authentication.service';
import { MulticlientService } from '../../core/services/multiclient.service';
import { SessionService } from '../../core/services/session.service';
import { FiltrosConsultaSolicitudesService } from '../../core/services/filtros-consulta-solicitudes.service';

@Component({
  selector: 'app-multiclient-selector',
  templateUrl: './multiclient-selector.component.html',
  styleUrls: ['./multiclient-selector.component.css']
})
export class MulticlientSelectorComponent implements OnInit {

  @Output() multiclientToggle = new EventEmitter<boolean>();

  clientsInfo: MulticlientInfoItem[] = [];
  selectedClientInfo: MulticlientInfoItem;
  unselectedClientInfo: MulticlientInfoItem[] = [];
  pressed = false;
  rangos = new Map<number, string>();
  uniqueClientId = 0;

  constructor(
    private multiclientService: MulticlientService,
    private auth: AuthenticationService,
    private router: Router,
    private translateService: TranslateService,
    private sessionService: SessionService,
    private filtrosConsultaSolicitudes: FiltrosConsultaSolicitudesService
  ) {
    this.rangos.set(0, this.translateService.instant('vistadetalle.rango.0'));
    this.rangos.set(1, this.translateService.instant('vistadetalle.rango.1'));
    this.rangos.set(2, this.translateService.instant('vistadetalle.rango.2'));
  }

  ngOnInit() {
    this.multiclientService.getMulticlientInfo().subscribe((infos: MulticlientInfoItem[]) => {

      this.clientsInfo = infos;
      this.selectClient(this.sessionService.getClientId());
      if (infos.length === 0 || this.unselectedClientInfo.length === 0) {
        this.uniqueClientId = this.sessionService.getClientId();
      }

    },
      error => { });
  }

  handle(type: string) {
    this.multiclientToggle.emit(type === 'show');
  }

  switchClient(idCliente: number) {
    if (idCliente && this.selectedClientInfo && this.selectedClientInfo.idCliente !== idCliente) {
      this.selectClient(idCliente);
      this.multiclientService.switchClient(this.selectedClientInfo.id).subscribe(result => {
        this.filtrosConsultaSolicitudes.resetFilters();
        this.auth.redirectToLoadUserData(false);
      });
    }
  }

  selectClient(idCliente: number) {
    this.selectedClientInfo = this.clientsInfo.find(info => info.idCliente === idCliente);
    this.unselectedClientInfo = this.clientsInfo.filter(info => info.idCliente !== idCliente);
  }

}
